import {
  Component,
  computed,
  inject,
  input,
  output,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';

import {
  AiScreeningResult,
  AiScreeningResultStatus,
  AiScreeningsResponse,
} from '@core/ai-screening-types';
import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import { ButtonComponent, IconComponent, IconName, RtTooltip } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-ai-screening-results-list',
  imports: [ButtonComponent, IconComponent, TranslatePipe, RtTooltip],
  templateUrl: './ai-screening-results-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ai-screening-results-list.component.less',
})
export class AiScreeningResultsListComponent {
  private readonly i18n = inject(I18nService);

  public screening = input.required<AiScreeningsResponse>();
  public editable = input.required();
  public hasScreenActions = input(false);
  public usageLimitReached = input(false);
  public expandable = input(false);
  public previewMode = input(false);

  public edit = output<AiScreeningResult>();
  public screenAgain = output<void>();

  protected disabledTooltip = computed(() => {
    if (!this.editable())
      return this.i18n.translate('app.ai_candidate_screening.results.no_permission');
    if (this.usageLimitReached())
      return this.i18n.translate('app.ai_candidate_screening.results.usage_limit_reached_tooltip');
    return '';
  });

  protected expandedMap = signal<Record<string, boolean>>({});
  protected statusIconMap: Record<AiScreeningResultStatus, IconName> = {
    fulfilled: 'check',
    unfulfilled: 'close',
    unverifiable: 'help-plain',
  };

  protected toggleExpand(id: string | number) {
    this.expandedMap.update(v => ({ ...v, [id]: !v[id] }));
  }
}
